import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { DialogContent, Button } from '@mui/material'

import { get } from 'utils/lodash'
import { handleError } from 'utils/error'
import { useLazyGetAllLocationNotesQuery, useCreateLocationNoteMutation, useUpdateLocationNoteMutation } from 'api/notes/locationNotesCrud'
import { getSortedNotes, getArchivedAndUnarchivedNotes } from 'data/notes/notesSelectors'

import T from 'T'
import HHBaseDialog from 'components/common/HHBaseDialog'
import HHDialogTitle from 'components/common/HHDialogTitle'
import HHDialogActions from 'components/common/HHDialogActions'
import LocationNotes from 'components/notes/location/LocationNotes'
import AddUpdateNoteDialog from 'components/notes/common/AddUpdateNoteDialog'
import NoteSkeleton from 'components/notes/common/NoteSkeleton'

const LocationNotesDialogVariant = ({ isOpen = false, locationId = '', getCachedData = false, onClose }) => {
  const [getAllLocationNotes, { isFetching, isLoading, data: notesData }] = useLazyGetAllLocationNotesQuery()
  const isGetAllNotesLoading = isFetching || isLoading
  const [isOpenAddUpdateNoteDialog, setIsOpenAddUpdateNoteDialog] = useState(null)

  const sortedNotes = getSortedNotes({ notes: get(notesData, 'notes', []) })
  const { unarchivedNotes: notes } = getArchivedAndUnarchivedNotes({ notes: sortedNotes })

  const handleOpenAddLocationNote = () => {
    setIsOpenAddUpdateNoteDialog(true)
  }

  const handleCloseAddLocationNote = () => {
    setIsOpenAddUpdateNoteDialog(false)
  }

  useEffect(() => {
    if (isOpen && locationId) {
      getAllLocationNotes({ id: locationId }, getCachedData).unwrap().catch(handleError)
    }
  }, [isOpen, locationId])

  return (
    <>
      <HHBaseDialog open={isOpen} maxWidth="md" fullWidth onClose={onClose}>
        <HHDialogTitle title={`${T.LOCATION_NOTE}s`} onClose={onClose} />
        <DialogContent sx={{ p: 0 }}>
          {isGetAllNotesLoading && <NoteSkeleton rows={1} />}
          {!isGetAllNotesLoading && (
            <LocationNotes
              itemSx={{
                [`.MuiListItemSecondaryAction-root`]: {
                  right: 12,
                },
              }}
              notes={notes}
              locationId={locationId}
              noNotesText={T.NO_LOCATION_NOTES}
            />
          )}
        </DialogContent>
        <HHDialogActions>
          <Button variant="outlined" onClick={handleOpenAddLocationNote}>
            {T.CREATE_NOTE}
          </Button>
          <Button variant="contained" onClick={onClose}>
            {T.CLOSE}
          </Button>
        </HHDialogActions>
      </HHBaseDialog>
      <AddUpdateNoteDialog
        id={locationId}
        isOpen={isOpenAddUpdateNoteDialog}
        title={T.NEW_LOCATION_NOTE}
        useCreateNoteMutation={useCreateLocationNoteMutation}
        useUpdateNoteMutation={useUpdateLocationNoteMutation}
        onClose={handleCloseAddLocationNote}
      />
    </>
  )
}

LocationNotesDialogVariant.propTypes = {
  isOpen: PropTypes.bool,
  locationId: PropTypes.string,
  getCachedData: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
}

export default LocationNotesDialogVariant
